import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { abbreviateNumber } from '@pascal/pascal-core';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store';
import { defineChipColor } from '../../helpers/chipColor';
import { doBetStore } from '../../store/doBetStore';

const BetChipSection = observer(
  ({ betType, groupType, handleDoChip, isInBoxSection, isLittleChip }) => {
    const { quickBets, chipByTypes } = doBetStore;
    const { activeFreeBet } = freeBetStore;

    const chip = useMemo(() => {
      if (!chipByTypes?.[betType]) {
        return null;
      }
      if (chipByTypes?.[betType]?.hasOwnProperty('winAmount')) {
        if (chipByTypes?.[betType].winAmount) {
          return chipByTypes?.[betType];
        }
        return 0;
      }
      return chipByTypes?.[betType];
    }, [chipByTypes, betType]);

    return (
      <div
        className='bet-on-poker-seat-chip'
        onClick={handleDoChip ? () => handleDoChip({ betType, groupType }) : null}
      >
        <div
          className={`pgc-bet-chip ${
            isLittleChip || `${chip?.winAmount || chip?.amount}`.length > 3 ? '' : 'large'
          } ${
            chip && activeFreeBet.id
              ? 'free-chip'
              : defineChipColor(chip ? chip.winAmount || chip.amount : 0, quickBets)
          } ${chip || isInBoxSection ? '' : 'empty'}`}
        >
          <div className='pgc-chip-number'>
            <p className='pgc-chip-number-text'>
              {abbreviateNumber(chip ? chip.winAmount || chip.amount : 0) || null}
            </p>
          </div>
        </div>
      </div>
    );
  }
);

export default BetChipSection;
